import React, { useState, useEffect } from "react";
import { Box } from "@chakra-ui/react";
import { keyframes } from "@emotion/react";

// Define keyframes for the animations
const bounceAndRotate = (item1, item2) => {
  return keyframes({
    "0%": {
      transform: "translate(0, 0) scale(1) rotate(0deg)",
    },
    "25%": {
      transform: `translate(${item1}px, ${item2}px) scale(1.1) rotate(45deg)`,
    },
    "50%": {
      transform: "translate(0, 0) scale(1) rotate(90deg)",
    },
    "75%": {
      transform: `translate(${item1}px, ${item2}px) scale(1.1) rotate(135deg)`,
    },
    "100%": {
      transform: "translate(0, 0) scale(1) rotate(180deg)",
    },
  });
};

const mergeToCenter = keyframes`
  0% {
    transform: translate(0, 0) scale(1);
  }
  50% {
    transform: translate(0, 0) scale(1.5);
  }
  100% {
    transform: translate(0, 0) scale(1);
  }
`;

const LoadingScreen = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000); // Adjust the timeout as needed
    return () => clearTimeout(timer);
  }, []);

  if (!loading) return null; // Hide component when not loading

  return (
    <Box
      position="fixed"
      top="0"
      left="0"
      w="100vw"
      h="100vh"
      bg="white"
      display="flex"
      justifyContent="center"
      alignItems="center"
      zIndex="9999"
      overflow="hidden"
    >
      <Box position="relative" w="120px" h="120px">
        {/* Square Boxes */}
        <Box
          w="50px"
          h="50px"
          bg="#090632"
          position="absolute"
          top="10px"
          left="10px"
          animation={`${bounceAndRotate("-50", "-50")} 2.5s infinite`}
        />
        <Box
          w="50px"
          h="50px"
          bg="#090632"
          position="absolute"
          top="10px"
          right="10px"
          animation={`${bounceAndRotate("50", "-50")} 2.5s infinite`}
        />
        <Box
          w="50px"
          h="50px"
          bg="#090632"
          position="absolute"
          bottom="10px"
          right="10px"
          animation={`${bounceAndRotate("50", "50")} 2.5s infinite`}
        />
        <Box
          w="50px"
          h="50px"
          bg="#090632"
          position="absolute"
          bottom="10px"
          left="10px"
          animation={`${bounceAndRotate("-50", "50")} 2.5s infinite`}
        />
      </Box>

      {/* Merging Center Animation */}
    </Box>
  );
};

export default LoadingScreen;
